import { isObject } from 'lodash';

import { objectKeysCamelToSnakeCase, removeNullValuesNestedObject } from '.';

export const getQueryString = (obj: Record<string, any>, prefix?: string): string => {
  if (!obj) {
    return;
  }

  const strings = [];

  Object.keys(obj).forEach((key) => {
    // eslint-disable-next-line no-prototype-builtins
    if (obj.hasOwnProperty(key)) {
      const k = prefix ? `${prefix}[${key}]` : key;
      const v = obj[key];

      strings.push(
        v !== null && isObject(v)
          ? getQueryString(v, k)
          : `${encodeURIComponent(k)}=${encodeURIComponent(v)}`
      );
    }
  });

  return strings.join('&');
};

export const getQueryStringToSnakeCase = (
  obj: Record<string, any>,
  {
    prefix,
    removeNullValues = false,
    excludeKeys = [],
  }: { prefix?: string; removeNullValues?: boolean; excludeKeys?: string[] } = {}
): string => {
  let data = objectKeysCamelToSnakeCase(obj, { excludeKeys });

  if (removeNullValues) {
    data = removeNullValuesNestedObject(data);
  }

  return getQueryString(data, prefix);
};
